import { useState } from 'react';
import { Header } from "./components/Header";
import { Footer } from "./components/Footer";
import { Home } from "./components/pages/Home";
import { About } from "./components/pages/About";
import { ProgramsPage } from "./components/pages/ProgramsPage";
import { GalleryPage } from "./components/pages/GalleryPage";
import { Contact } from "./components/pages/Contact";

export default function App() {
  const [currentPage, setCurrentPage] = useState('home');

  const handleNavigate = (page: string) => {
    setCurrentPage(page);
    window.scrollTo(0, 0); // Scroll to top when navigating
  };

  const renderPage = () => {
    switch (currentPage) {
      case 'about':
        return <About />;
      case 'programs':
        return <ProgramsPage />;
      case 'gallery':
        return <GalleryPage />;
      case 'contact':
        return <Contact />;
      default:
        return <Home />;
    }
  };

  return (
    <div className="min-h-screen">
      <Header currentPage={currentPage} onNavigate={handleNavigate} />
      {renderPage()}
      <Footer onNavigate={handleNavigate} />
    </div>
  );
}